export class Credentials{
    public ApplicationMemberId:string;
    public TestMemberId:string;
    public AccessKey:string;
    public AuthenticationExpiresInSeconds:number = 100000;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/credentials.ts